export default class EventAdditionalPriceDefinitions {
    id: number
    eventId: number
    eventAdditionalPriceTypeId: number
    eventAdditionalPriceTypeName: string
    priceValue: number
    description: string
    limitCount: number
    memberGroupTypeId: number
    newMemberGroupTypeIds: number[]
    memberGroupTypeName: string
    memberAgeGroupId: number
    newMemberAgeGroupIds: number[]
    memberAgeGroupName: string
    [key: string]: any
}